import {  Typography } from '@material-ui/core'
import Email from '../../assets/svg/Email.svg'
import NEUniteLogo from '../../assets/svg/Logo.svg'
import { useNotFoundStyles } from '../../styles/muiStyles';

const EmailConfirmation = () =>{
    
    const classes= useNotFoundStyles();
    return (
        <div>
            <div style={{display:'flex',alignItems:'center',}}>
                <img src={NEUniteLogo} alt="logo" style ={{width:'5vw', height:'5vw', margin:'1.5vw'}} />
                <Typography variant='h6' style={{color:'white',textShadow: '2px 2px #7a7878', letterSpacing:'.3vw'}}>
                        <strong> <i>NEUMeet</i></strong>
                </Typography>
            </div>
            <div className = {classes.root} >
                <div>
                    <img src={Email} alt="Sent email" />
                </div>
                <div  style ={{textAlign:'center'}}>
                    <Typography variant='h4'  style ={{marginBottom:'1vw', letterSpacing:'.3vw'}}>
                        <strong> <i>Welcome!</i></strong>
                    </Typography>
                    <Typography variant='h5' style ={{marginBottom:'1vw', letterSpacing:'.3vw'}}>
                        <strong>
                            Please Check your email to continue the registration
                        </strong>
                    </Typography>
                </div> 
            </div>
        </div>
    );
};

export default EmailConfirmation;
